export default __webpack_public_path__ + "static/media/logo.33151216.png";